module.exports = __webpack_public_path__ + "static/banner-860e05f14590ede27c5345db72d95792.jpg";